import { useEffect, useRef, useState } from 'react';

export const useVisibility = () => {
	const ref = useRef(null);
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const onCheckVisibility = () => setIsVisible(ref.current && ref.current.checkVisibility());
		onCheckVisibility();

		window.addEventListener('resize', onCheckVisibility);
		return () => window.removeEventListener('resize', onCheckVisibility);
	}, []);

	return { ref, isVisible };
};
